import { type RecentSearchLocation } from '@/components/shared/search-location-modal/useLocationSearchSuggestions'
import { LocalStorageRegistry } from '@/constants/localStorageRegistry'

export const getRecentLocationsFromLocalStorage = () => {
  if (typeof window === 'undefined') return []

  const storedSearchLocations = window.localStorage.getItem(LocalStorageRegistry.RECENT_LOCATIONS)

  const recentSearchLocations: RecentSearchLocation[] | [] = storedSearchLocations
    ? JSON.parse(storedSearchLocations)
    : []

  return recentSearchLocations
}
